import script from "./QuizBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizBlock.vue?vue&type=script&setup=true&lang=js"

import "./QuizBlock.vue?vue&type=style&index=0&id=c1d97708&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1d97708"]])

export default __exports__